<div class="alert" [ngClass]="[testSuccess.show ? 'show-alert' : 'hide-alert', testSuccess.ok ? 'success' : 'danger']">
  <h2 class="heading-underline">
    <i class="bhi-check"></i>{{ testSuccess.title }}
    <i class="bhi-times" (click)="hide()"></i>
  </h2>
  <p>{{ testSuccess.msg }}</p>
</div>
